angular.module('app.filters').filter('detectedProVideoInput', function($filter) {
    return function(input) {
        if ((input.height > 0) && (input.width > 0) && (input.framerate > 0)) {
            let framerate = input.framerate;
            framerate = Math.round(framerate * 100) / 100;
            return `${input.height}${input.interlaced ? 'i' : 'p'}${framerate}`;
        } else {
            return '';
        }
    };
});


// WEBPACK FOOTER //
// ./filters/detected_pro_video_input.js